import { render, staticRenderFns } from "./billingDetails.vue?vue&type=template&id=1b8f44b2&scoped=true"
import script from "./billingDetails.vue?vue&type=script&lang=js"
export * from "./billingDetails.vue?vue&type=script&lang=js"
import style0 from "./billingDetails.vue?vue&type=style&index=0&id=1b8f44b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f44b2",
  null
  
)

export default component.exports